import { useMutation } from '@apollo/client';

import { CreateSurveyAnswersData } from 'app/shared/typings/surveyQuestions';

import { CREATE_SURVEY_ANSWERS } from './mutations';

export const CreateSurveyAnswers = () => {
  return useMutation<CreateSurveyAnswersData>(CREATE_SURVEY_ANSWERS)[0];
};
